import OBase from './OBase';
import * as Geometry from '../geometry';

export default class EExtrude extends OBase {
  update () {
    let thicknessTree = this.getFloatInput('thickness');
    let surfacePathTree = this.getSurfaceObjectInput('surface');

    // console.log(thicknessTree,  surfacePathTree)
    let output = this.getGenericObjectOutput('geometry');
    let dataTrees = [thicknessTree, surfacePathTree];
    let outDataTrees = [];

    // https://github.com/r3mi/poly2tri.js/

    let outTree = new Geometry.DataTree();

    // MEMO:
    // 値をスケールすると、poly2triの以下のエラー
    // - poly2tri EdgeEvent: Collinear not supported!
    // の出現頻度をマシにすることができる（計算誤差に起因している？）
    const precision = 1e4;

    if (surfacePathTree !== null && surfacePathTree.branchCount() > 0) {
      Geometry.makeMultiplePairs(dataTrees, outDataTrees);
      for (let m = 0; m < outDataTrees[0].branches.length; m++) {
        for (let s = 0; s < outDataTrees[0].branches[m].length; s++) {
          let thickness = outDataTrees[0].branches[m][s];
          let surfacePaths = outDataTrees[1].branches[m][s];
          if (surfacePaths.length <= 0) continue;

          let polygons = [];
          let holes = [];
          let surfaces = []; // for debug

          for (let i = 0; i < surfacePaths.length; i++) {
            let surfacePath = this.removeDuplicated(surfacePaths[i]);

            const contour = surfacePath.map(p => new Poly2Tri.Point(p.X * precision, p.Y * precision));

            // a surfacePath is counter-clock-wise or not
            if (ClipperLib.Clipper.Orientation(surfacePath) || (surfacePaths.length <= 1)) {
              let swctx = new Poly2Tri.SweepContext(contour);
              polygons.push(swctx);
              surfaces.push(contour.map(p => p)); // for debug
              // console.log('srf' + i)
            } else {
              holes.push(contour);
              // console.log('hole' + i)
            }
          }
          // console.log('||||')
          //
          // console.log(polygons.length)
          // console.log(holes.length)
          // console.log(polygons)
          // console.log('----------')

          if (polygons.length > 0) {
            holes.forEach(hole => polygons[0].addHole(hole));
          } else {
            console.warn('# of polygons is zero');
          }

          let geometry = new Geometry.GHGeometry();
          let triangles = [];

          try {
            for (let i in polygons) {
              let swctx = polygons[i];
              swctx.triangulate();
              swctx.getTriangles().forEach((tri) => {
                triangles.push(tri);
              });
            }
          } catch (e) {
            // console.log(surfaces)
            // global.debugger.debugPolygon(surfaces, holes)
            console.warn(e);
            throw e;
          }

          triangles.forEach((tri) => {
            let points = tri.getPoints();
            let p0 = points[0];
            let p1 = points[1];
            let p2 = points[2];

            /*
            let b0 = new THREE.Vector3(p0.x, 0, p0.y)
            let b1 = new THREE.Vector3(p1.x, 0, p1.y)
            let b2 = new THREE.Vector3(p2.x, 0, p2.y)
            let t0 = new THREE.Vector3(p0.x, thickness, p0.y)
            let t1 = new THREE.Vector3(p1.x, thickness, p1.y)
            let t2 = new THREE.Vector3(p2.x, thickness, p2.y)
            */

            let b0 = new THREE.Vector3(p0.x / precision, p0.y / precision, 0);
            let b1 = new THREE.Vector3(p1.x / precision, p1.y / precision, 0);
            let b2 = new THREE.Vector3(p2.x / precision, p2.y / precision, 0);
            let t0 = new THREE.Vector3(p0.x / precision, p0.y / precision, thickness);
            let t1 = new THREE.Vector3(p1.x / precision, p1.y / precision, thickness);
            let t2 = new THREE.Vector3(p2.x / precision, p2.y / precision, thickness);

            let offset = geometry.vertices.length;
            geometry.vertices.push(b0, b1, b2);
            geometry.vertices.push(t0, t1, t2);

            const i0 = offset;
            const i1 = offset + 1;
            const i2 = offset + 2;
            const i3 = offset + 3;
            const i4 = offset + 4;
            const i5 = offset + 5;

            geometry.faces.push(new THREE.Face3(i0, i1, i2));
            // geometry.faces.push(new THREE.Face3(i0, i2, i1))
            geometry.faces.push(new THREE.Face3(i5, i4, i3));
            // geometry.faces.push(new THREE.Face3(i0, i2, i1))
          });

          // build sides
          for (let i = 0; i < surfacePaths.length; i++) {
            let surfacePath = surfacePaths[i];

            let offset = geometry.vertices.length;
            let len = surfacePath.length;
            for (let j = 0; j < len; j++) {
              let p = surfacePath[j];

              /*
              let b = new THREE.Vector3(p.X, 0, p.Y)
              let t = new THREE.Vector3(p.X, thickness, p.Y)
              */
              let b = new THREE.Vector3(p.X, p.Y, 0);
              let t = new THREE.Vector3(p.X, p.Y, thickness);

              geometry.vertices.push(b, t);

              let i0 = offset + j * 2;
              let i1 = offset + j * 2 + 1;
              let i2 = offset + ((j + 1) % len) * 2;
              let i3 = offset + ((j + 1) % len) * 2 + 1;

              geometry.faces.push(new THREE.Face3(i0, i1, i2));
              geometry.faces.push(new THREE.Face3(i3, i2, i1));
            }
          }

          geometry.computeFaceNormals();
          // geometry.center()

          outTree.add(geometry, outDataTrees[0].paths[m]);
        }
      }
    } else {
      let empty = new Geometry.GHGeometry();
      outTree.add(empty, new Geometry.GHPath(0));
    }
    output.value = outTree;
  }

  removeDuplicated (points) {
    let result = [];
    const epsilon = 1e-10;
    for (let i = 0, n = points.length; i < n; i++) {
      let p = points[i];
      let found = result.find((other) => {
        return (Math.abs(other.X - p.X) < epsilon && Math.abs(other.Y - p.Y) < epsilon);
      });
      if (found === undefined) {
        result.push(p);
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EExtrude.js